var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconSpinner = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 18 18",
  width: "1em",
  height: "1em"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M11.938 15.484A7.382 7.382 0 0 1 9.21 16C5.184 16 2 12.823 2 9s3.184-7 7.21-7c3.023 0 5.571 1.79 6.654 4.3H18C16.826 2.649 13.335 0 9.21 0 4.125 0 0 4.03 0 9s4.124 9 9.21 9c1.02 0 2-.162 2.917-.46l-.19-2.056Z",
  clipRule: "evenodd"
})));
export default SvgIconSpinner;